import { redirect } from 'react-router-dom';
import { getParamsFromStoreRedux } from 'store/utils';
import {
  getPostFlowUrl,
  getReturnUrlFromRequestLoader,
} from 'utils/common/route';

import * as messagesActions from 'pages/messages/controllers/actions';

export const messagesLoader = ({ request }) => {
  const returnUrl = getReturnUrlFromRequestLoader(request) || '/';

  const { dispatch, getState } = getParamsFromStoreRedux();

  const state = getState();
  const messages = state.user?.userInfo?.messages;
  const alerts = state.user?.userInfo?.alerts;

  dispatch(messagesActions.getMessages(messages));
  dispatch(messagesActions.getAlerts(alerts));

  const redirectUrl = getPostFlowUrl({
    type: 'notification',
    returnUrl,
    dispatch,
  });

  throw redirect(redirectUrl);
};
